import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarSparkleFilledSize48Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={48}
            height={48}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M18 12c4.5 6.75 11.25 13.5 18 18-6.75 4.5-13.5 11.25-18 18-4.5-6.75-11.25-13.5-18-18 6.75-4.5 13.5-11.25 18-18"
                        fill="currentColor"
                    />
                    <path
                        d="M38 0c2.5 3.75 6.25 7.5 10 10-3.75 2.5-7.5 6.25-10 10-2.5-3.75-6.25-7.5-10-10 3.75-2.5 7.5-6.25 10-10"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HyperstarSparkleFilledSize48Glyph.displayName = 'HyperstarSparkleFilledSize48Glyph';
